import { Skeleton, Stack } from '@mui/material';

export const PaginationSkeleton = () => (
  <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
    <Skeleton variant="rounded" width={'24%'} height={'48px'} />
  </Stack>
);
